import { InventoryCategory } from "@onmo/graphql/graphql";

export const INVENTORIES_CATEGORY = [InventoryCategory.Epay];

export enum ItemDetailTab {
    TermsAndConditions = "Terms & Conditions",
    ProductInfo = "Product Info",
    Redeem = "Redeem"
}

export const ItemCurrencySymbol = new Map<string, string>([
    ["USD", "$"],
    ["ZAR", "R"]
]);